import React, { useEffect } from 'react';
import {
    changeNameAll,
    changeTitle1All,
    changeTitle2All,
    changeDepartment1All,
    changeDepartment2All,
    changePhoneAll,
    changeFaxAll,
    changeNursePhoneAll,
    changeAddressAll,
    changeCityAll,
    changeStateAll,
    changeZipAll,
    changeSuiteRoomAll,
    getAddressLineP1T15,
} from './../CanvasActions';
import TextField from './../Form/TextField';
import SelectField from './../Form/SelectField';

const FormP1T15 = React.memo((props) => {
    useEffect(() => {
        changeNameAll(props.name);
    }, [props.name]);

    useEffect(() => {
        changeTitle1All(props.title1);
    }, [props.title1]);

    useEffect(() => {
        changeTitle2All(props.title2);
    }, [props.title2]);

    useEffect(() => {
        changeDepartment1All(props.department1);
    }, [props.department1]);

    useEffect(() => {
        changeDepartment2All(props.department2);
    }, [props.department2]);

    useEffect(() => {
        changePhoneAll(props.phone);
    }, [props.phone]);

    useEffect(() => {
        changeFaxAll(props.fax);
    }, [props.fax]);

    useEffect(() => {
        changeNursePhoneAll(props.nursePhone);
    }, [props.nursePhone]);

    useEffect(() => {
        changeAddressAll(props.address);
    }, [props.address]);

    useEffect(() => {
        changeCityAll(props.city);
    }, [props.city]);

    useEffect(() => {
        changeStateAll(props.state);
    }, [props.state]);

    useEffect(() => {
        changeZipAll(props.zip);
    }, [props.zip]);

    useEffect(() => {
        changeSuiteRoomAll(props.suiteRoom);
    }, [props.suiteRoom]);

    const handleSetAddress = (value) => {
        changeAddressAll(value);
        const address = getAddressLineP1T15();

        if (address.length > 61) {
            props.setAddress(props.address);
            changeAddressAll(props.address);
        } else {
            props.setAddress(value);
        }
    };

    const handleSetSuiteRoom = (value) => {
        changeSuiteRoomAll(value);
        const address = getAddressLineP1T15();

        if (address.length > 61) {
            props.setSuiteRoom(props.suiteRoom);
            changeSuiteRoomAll(props.suiteRoom);
        } else {
            props.setSuiteRoom(value);
        }
    };

    const handleSetCity = (value) => {
        changeCityAll(value);
        const address = getAddressLineP1T15();

        if (address.length > 61) {
            props.setCity(props.city);
            changeCityAll(props.city);
        } else {
            props.setCity(value);
        }
    };

    const handleSetZip = (value) => {
        changeZipAll(value);
        const address = getAddressLineP1T15();

        if (address.length > 61) {
            props.setZip(props.zip);
            changeZipAll(props.zip);
        } else {
            props.setZip(value);
        }
    };

    const renderCount = (value, limit) => {
        let count = 0;
        if (value) {
            count = value.length;
        }

        return <div className="limit-message">{count}/{limit} characters</div>;
    };

    return (
        <form action="">
            <hr />
            <TextField
                required
                label="Name"
                limit="55"
                showCount
                placeholder="Name and credentials"
                value={props.name}
                setFunction={props.setName}
            />
            <TextField
                required
                label="Title 1"
                limit="61"
                showCount
                value={props.title1}
                setFunction={props.setTitle1}
            />
            <TextField
                label="Title 2"
                limit="61"
                showCount
                value={props.title2}
                setFunction={props.setTitle2}
            />
            <TextField
                required
                label="Clinic Name 1"
                limit="55"
                showCount
                value={props.department1}
                setFunction={props.setDepartment1}
                placeholder="Clinic Name Line 1"
            />
            <TextField
                label="Clinic Name 2"
                limit="55"
                showCount
                value={props.department2}
                setFunction={props.setDepartment2}
                placeholder="Clinic Name Line 2"
            />
            <hr />
            <TextField
                required
                label="Address"
                value={props.address}
                setFunction={handleSetAddress}
                placeholder="Address"
            />
            <TextField
                label="Ste #"
                value={props.suiteRoom}
                setFunction={handleSetSuiteRoom}
                placeholder="Ste/Building #"
            />
            <TextField
                required
                label="City"
                value={props.city}
                setFunction={handleSetCity}
            />
            <TextField
                required
                label="Zip"
                value={props.zip}
                setFunction={handleSetZip}
            />
            {renderCount(getAddressLineP1T15(), 61)}
            <TextField
                required
                isPhone
                phoneFormat={3}
                label="Phone"
                limit="12"
                value={props.phone}
                setFunction={props.setPhone}
                placeholder="Main or direct phone number"
            />
            <TextField
                isPhone
                phoneFormat={3}
                label="Fax"
                limit="12"
                value={props.fax}
                setFunction={props.setFax}
                placeholder="Fax number"
            />
            <TextField
                isPhone
                phoneFormat={3}
                label="Nurse Phone"
                limit="12"
                value={props.nursePhone}
                setFunction={props.setNursePhone}
                placeholder="Nurse Phone"
            />
            <hr />
            <SelectField
                required
                label="Quantity"
                value={props.quantity}
                setFunction={props.setQuantity}
                options={[
                    { value: '', label: 'Select option' },
                    { value: '250', label: '250' },
                    { value: '500', label: '500' },
                    { value: '1000', label: '1000' },
                ]}
            />
            <hr />
            <h5 className="description-header">Description</h5>
            <div className="description-section">
                <div><span className="label">Title:</span> Co-branded Provider Appointment Reminder Card</div>
                <div className="mt-2">
                    <span className="label">Description:</span> This double-sided card is available for clinics to
                    provide an appointment reminder card to a patient listing the specific provider on the front and
                    appointment details on the back.
                </div>
                <div className="description-list">
                    <span className="label">Specs:</span>
                    <ul>
                        <li>Variable on front</li>
                        <li>3.5x2"</li>
                        <li>Double-sided with Color</li>
                        <li>100# Uncoated Cover</li>
                    </ul>
                </div>
            </div>
        </form>
    );
});

export default FormP1T15;
